<freud-card
	class="zk-mt-2 zk-block history-card"
	[ngClass]="{
		'history-card__retracted': !isOpen,
		'history-card__expanded': isOpen
	}"
>
	<div class="zk-flex zk-justify-between zk-items-center">
		<div class="zk-flex zk-items-center zk-gap-1">
			<span class="freud-icon freud-icon-file-text freud-icon-md"></span>
			<span class="history__date">{{ formatDate(date) }}</span>
		</div>
		<span
			*ngIf="note?.length > 92 || (note | highlight: highlightIndexes)?.includes('<br>')"
			(click)="isOpen = !isOpen"
			class="freud-icon-chevron-down"
			[ngClass]="{
				'freud-icon-chevron-up': isOpen,
				'freud-icon-chevron-down': !isOpen
			}"
		></span>
	</div>
	<span class="history-description" *ngIf="note" [innerHTML]="note | highlight: highlightIndexes">
	</span>
</freud-card>
